var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 0H10C4.47715 0 0 4.47715 0 10V51C0 56.5228 4.47715 61 10 61H51C56.5228 61 61 56.5228 61 51V10C61 4.47715 56.5228 0 51 0Z",
    fill: "#FFE9DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2802 15C44.2303 15 43.1983 15.3937 42.4064 16.1497L28.8116 29.1094L28.5096 29.3981L28.4273 29.8089L27.4803 34.4027L27.0549 36.3294L29.0682 35.9226L33.8715 35.0169L34.3011 34.9382L34.603 34.6494L48.154 21.6478C48.7215 21.1031 49.1078 20.41 49.2642 19.6558C49.4205 18.9015 49.34 18.1199 49.0327 17.4093C48.7254 16.6987 48.2051 16.091 47.5374 15.6628C46.8696 15.2345 46.0842 15.0048 45.2802 15.0026V15ZM45.2802 17.5462C45.6027 17.5462 45.917 17.7037 46.2244 17.9964C46.8365 18.5818 46.8365 19.2144 46.2244 19.8011L32.9287 32.514L30.5682 32.9655L31.0417 30.708L44.3374 17.9925C44.6434 17.6998 44.9577 17.5423 45.2802 17.5423V17.5462ZM16.4601 20.2106V46.4606H43.9078V29.1514L41.163 31.7764V43.8356H19.2049V22.8356H31.8143L34.5591 20.2106H16.4601Z",
    fill: "#FE9343",
    stroke: "#FE9343",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRca);
export default __webpack_public_path__ + "static/media/rca.462c723f33f0c5a2ea724fb1f847136c.svg";
export { ForwardRef as ReactComponent };